<template>
  <div class="global-settings-page" v-loading="loading">
    <div class="page-header">
      <div class="title-section">
        <h2 class="page-title">整体设置</h2>
        <p class="page-subtitle">这里的选项会随每个角色的脚本配置一起下发到设备端。下方四个平台可同时填写密钥，仅「当前使用」勾选一个。</p>
      </div>
      <el-button type="primary" :loading="saving" @click="handleSave">保存</el-button>
    </div>

    <template v-if="form">
      <el-card class="section-card" shadow="never">
        <template #header>
          <span class="card-title">自动过测谎</span>
        </template>

        <div class="field-row">
          <span class="field-label">启用</span>
          <el-switch v-model="form['自动过测谎'].enabled" />
        </div>

        <div class="platform-section-label">打码平台（单选当前使用，凭据可全部先填好）</div>

        <el-radio-group v-model="form['自动过测谎'].platform" class="platform-radio-group">
          <div class="platform-grid">
            <div
              class="platform-card"
              :class="{ 'platform-card--active': form['自动过测谎'].platform === 'yescaptcha' }"
            >
              <div class="platform-card__head">
                <el-radio label="yescaptcha" class="platform-radio">YesCaptcha</el-radio>
                <a
                  class="platform-link"
                  href="https://yescaptcha.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                >官网</a>
              </div>
              <p class="platform-hint">仪表盘获取 ClientKey</p>
              <el-input
                class="gs-input"
                v-model="form['自动过测谎'].yescaptcha.clientKey"
                placeholder="ClientKey"
                clearable
                show-password
              />
            </div>

            <div
              class="platform-card"
              :class="{ 'platform-card--active': form['自动过测谎'].platform === 'hyocr' }"
            >
              <div class="platform-card__head">
                <el-radio label="hyocr" class="platform-radio">火眼答题</el-radio>
                <a
                  class="platform-link"
                  href="http://www.hyocr.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                >官网</a>
              </div>
              <p class="platform-hint">用户主页获取密码串（默认平台）</p>
              <el-input
                class="gs-input"
                v-model="form['自动过测谎'].hyocr.authCode"
                placeholder="密码串"
                clearable
                show-password
              />
            </div>

            <div
              class="platform-card"
              :class="{ 'platform-card--active': form['自动过测谎'].platform === 'ttshitu' }"
            >
              <div class="platform-card__head">
                <div class="platform-card__title-wrap">
                  <el-radio label="ttshitu" class="platform-radio">图鉴打码</el-radio>
                  <span class="platform-recommend-tag">（推荐 带自学习 正确率高）</span>
                </div>
                <a
                  class="platform-link"
                  href="http://ttshitu.com/user/index.html"
                  target="_blank"
                  rel="noopener noreferrer"
                >官网</a>
              </div>
              <p class="platform-hint">账号与密码</p>
              <el-input
                class="gs-input gs-input-stack"
                v-model="form['自动过测谎'].ttshitu.username"
                placeholder="账号"
                clearable
              />
              <el-input
                class="gs-input"
                v-model="form['自动过测谎'].ttshitu.password"
                type="password"
                placeholder="密码"
                clearable
                show-password
              />
            </div>

            <div
              class="platform-card"
              :class="{ 'platform-card--active': form['自动过测谎'].platform === 'tuling' }"
            >
              <div class="platform-card__head">
                <el-radio label="tuling" class="platform-radio">图灵打码</el-radio>
                <a
                  class="platform-link"
                  href="https://fdyscloud.com.cn/"
                  target="_blank"
                  rel="noopener noreferrer"
                >官网</a>
              </div>
              <p class="platform-hint">账号与密码</p>
              <el-input
                class="gs-input gs-input-stack"
                v-model="form['自动过测谎'].tuling.username"
                placeholder="账号"
                clearable
              />
              <el-input
                class="gs-input"
                v-model="form['自动过测谎'].tuling.password"
                type="password"
                placeholder="密码"
                clearable
                show-password
              />
            </div>
          </div>
        </el-radio-group>
      </el-card>

      <el-card class="section-card" shadow="never">
        <template #header>
          <span class="card-title">GM训练测谎</span>
        </template>

        <div class="field-row">
          <span class="field-label">AI 选择</span>
          <el-radio-group v-model="form['GM训练测谎'].ai_provider">
            <el-radio
              v-for="item in AI_PROVIDER_OPTIONS"
              :key="item.value"
              :label="item.value"
            >
              {{ item.label }}
            </el-radio>
          </el-radio-group>
        </div>

        <div class="provider-config-block">
          <template v-if="form['GM训练测谎'].ai_provider === AI_PROVIDER_CLAUDE">
            <div class="field-row">
              <span class="field-label">API Key</span>
              <el-input
                class="gs-input gs-input--wide"
                v-model="form['GM训练测谎'].claude.api_key"
                placeholder="Lemon API Key"
                clearable
                show-password
              />
            </div>
            <div class="field-row">
              <span class="field-label">模型</span>
              <el-select v-model="form['GM训练测谎'].claude.model" class="model-select-wide">
                <el-option
                  v-for="item in CLAUDE_MODEL_OPTIONS"
                  :key="item"
                  :label="item"
                  :value="item"
                />
              </el-select>
            </div>
          </template>
          <template v-else>
            <div class="field-row">
              <span class="field-label">API Key</span>
              <el-input
                class="gs-input gs-input--wide"
                v-model="form['GM训练测谎'].ark.api_key"
                placeholder="火山方舟 API Key"
                clearable
                show-password
              />
            </div>
            <div class="field-row">
              <span class="field-label">模型</span>
              <ArkModelSelect v-model="form['GM训练测谎'].ark.model" />
            </div>
          </template>
        </div>

        <div class="field-row field-row--top">
          <span class="field-label">AI Prompt</span>
          <div class="prompt-editor">
            <div class="prompt-editor__toolbar">
              <el-button size="small" @click="restoreGmTrainLiePrompt">还原默认</el-button>
            </div>
            <el-input
              v-model="form['GM训练测谎'].prompt"
              type="textarea"
              :rows="18"
              class="gs-textarea"
              placeholder="AI 测谎答题 Prompt"
            />
          </div>
        </div>
        <p class="field-hint">支持占位符：<code>${role_name}</code>、<code>${vocation_name}</code>、<code>${level}</code>、<code>${问题}</code>、<code>{题库按顺序拼接}</code>。</p>
      </el-card>

      <el-card class="section-card" shadow="never">
        <template #header>
          <span class="card-title">其他配置</span>
        </template>
        <el-checkbox v-model="form['其他']['自动更新']">自动更新</el-checkbox>
      </el-card>
    </template>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue'
import { ElMessage } from 'element-plus'
import { getGlobalConfig, saveGlobalConfig } from '../api/configs'
import { defaultGmTrainLieConfig, confirmRestoreDefaultPrompt, ensureGmTrainLieConfig, AI_PROVIDER_OPTIONS, AI_PROVIDER_CLAUDE, AI_PROVIDER_ARK, CLAUDE_MODEL_OPTIONS } from '../constants/gmTrainLiePrompt'
import ArkModelSelect from '../components/ArkModelSelect.vue'

function defaultContent() {
  return {
    自动过测谎: {
      enabled: true,
      platform: 'hyocr',
      links: {
        yescaptcha: 'https://yescaptcha.com/',
        hyocr: 'http://www.hyocr.com/',
        ttshitu: 'http://ttshitu.com/user/index.html',
        tuling: 'https://fdyscloud.com.cn/'
      },
      yescaptcha: { clientKey: '' },
      hyocr: { authCode: '' },
      ttshitu: { username: '', password: '' },
      tuling: { username: '', password: '' }
    },
    其他: {
      自动更新: false
    },
    'GM训练测谎': defaultGmTrainLieConfig()
  }
}

function deepMerge(base, over) {
  if (!over || typeof over !== 'object') {
    return base
  }
  for (const key of Object.keys(over)) {
    const v = over[key]
    const b = base[key]
    if (
      v &&
      typeof v === 'object' &&
      !Array.isArray(v) &&
      b &&
      typeof b === 'object' &&
      !Array.isArray(b)
    ) {
      deepMerge(b, v)
    } else if (v !== undefined) {
      base[key] = v
    }
  }
  return base
}

export default {
  name: 'GlobalSettings',
  components: { ArkModelSelect },
  setup() {
    const loading = ref(false)
    const saving = ref(false)
    const form = ref(null)

    const load = async () => {
      loading.value = true
      try {
        const res = await getGlobalConfig()
        if (res.code === 200 && res.data) {
          const merged = defaultContent()
          deepMerge(merged, res.data)
          ensureGmTrainLieConfig(merged['GM训练测谎'])
          form.value = merged
        } else {
          ElMessage.error(res.message || '加载失败')
          form.value = defaultContent()
        }
      } catch (e) {
        console.error(e)
        ElMessage.error('加载整体设置失败')
        form.value = defaultContent()
      } finally {
        loading.value = false
      }
    }

    const handleSave = async () => {
      if (!form.value) return
      saving.value = true
      try {
        const res = await saveGlobalConfig(form.value)
        if (res.code === 200) {
          ElMessage.success(res.message || '保存成功')
          if (res.data) {
            const merged = defaultContent()
            deepMerge(merged, res.data)
            form.value = merged
          }
        } else {
          ElMessage.error(res.message || '保存失败')
        }
      } catch (e) {
        console.error(e)
        ElMessage.error('保存失败')
      } finally {
        saving.value = false
      }
    }

    const restoreGmTrainLiePrompt = async () => {
      if (!form.value?.['GM训练测谎']) return
      await confirmRestoreDefaultPrompt((prompt) => {
        form.value['GM训练测谎'].prompt = prompt
      })
    }

    onMounted(() => {
      load()
    })

    return {
      loading,
      saving,
      form,
      handleSave,
      restoreGmTrainLiePrompt,
      AI_PROVIDER_OPTIONS,
      AI_PROVIDER_CLAUDE,
      AI_PROVIDER_ARK,
      CLAUDE_MODEL_OPTIONS
    }
  }
}
</script>

<style scoped>
.global-settings-page {
  width: 100%;
  max-width: none;
  margin: 0;
  padding: 0 0 32px;
  box-sizing: border-box;
}

.page-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 20px;
  padding-bottom: 16px;
  border-bottom: 1px solid #e8e9ea;
  gap: 16px;
}

.title-section {
  flex: 1;
  min-width: 0;
}

.title-section .page-title {
  margin: 0;
  font-size: 22px;
  font-weight: 600;
  color: #1d1d1f;
}

.page-subtitle {
  margin: 6px 0 0;
  color: #666;
  font-size: 13px;
  line-height: 1.55;
  max-width: 960px;
}

.page-subtitle code {
  font-size: 12px;
  background: #f0f2f5;
  padding: 1px 6px;
  border-radius: 4px;
}

.section-card {
  margin-bottom: 16px;
  border-radius: 12px;
  width: 100%;
}

.card-title {
  font-weight: 600;
  font-size: 15px;
}

.field-row {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 16px;
}

.field-row .gs-textarea {
  flex: 1;
  min-width: 0;
}

.field-label {
  min-width: 72px;
  color: #444;
  font-size: 14px;
}

.platform-section-label {
  font-size: 13px;
  color: #555;
  margin-bottom: 12px;
  font-weight: 500;
}

.platform-radio-group {
  display: block;
  width: 100%;
}

.platform-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 16px;
  width: 100%;
}

@media (max-width: 768px) {
  .platform-grid {
    grid-template-columns: 1fr;
  }
}

.platform-card {
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  padding: 14px 16px 16px;
  background: #fafbfc;
  transition: border-color 0.2s ease, box-shadow 0.2s ease, background 0.2s ease;
}

.platform-card--active {
  border-color: #94a3b8;
  background: #fff;
  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.06);
}

.platform-card__head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 10px;
  margin-bottom: 8px;
}

.platform-card__title-wrap {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px 8px;
  min-width: 0;
  flex: 1;
}

.platform-recommend-tag {
  color: #dc2626;
  font-size: 13px;
  font-weight: 700;
  line-height: 1.35;
  letter-spacing: 0.02em;
  text-shadow: 0 0 1px rgba(220, 38, 38, 0.35);
  white-space: normal;
}

.platform-link {
  font-size: 13px;
  color: #2563eb;
  text-decoration: none;
  white-space: nowrap;
  flex-shrink: 0;
}

.platform-link:hover {
  text-decoration: underline;
}

.platform-hint {
  margin: 0 0 10px;
  font-size: 12px;
  color: #64748b;
  line-height: 1.4;
}

/* 单选：去掉默认外边距，与卡片对齐 */
.global-settings-page :deep(.platform-radio.el-radio) {
  margin-right: 0;
  height: auto;
  white-space: normal;
  align-items: flex-start;
}

.global-settings-page :deep(.platform-radio .el-radio__label) {
  font-size: 15px;
  font-weight: 600;
  color: #1e293b;
  padding-left: 8px;
}

.global-settings-page :deep(.platform-card--active .platform-radio .el-radio__label) {
  color: #0f172a;
}

/* 本页专用输入框：覆盖 App.vue 全局大号 el-input，避免「被压扁/不协调」 */
.global-settings-page :deep(.gs-input .el-input__wrapper) {
  border-radius: 10px !important;
  padding: 8px 12px !important;
  min-height: 40px !important;
  font-size: 14px !important;
  line-height: 1.4 !important;
  border: 1px solid #d1d5db !important;
  background-color: #ffffff !important;
  box-shadow: none !important;
}

.global-settings-page :deep(.gs-input .el-input__wrapper:hover) {
  border-color: #9ca3af !important;
  box-shadow: none !important;
}

.global-settings-page :deep(.gs-input .el-input__wrapper.is-focus) {
  border-color: #64748b !important;
  box-shadow: 0 0 0 2px rgba(100, 116, 139, 0.15) !important;
}

.global-settings-page :deep(.gs-input .el-input__inner) {
  font-size: 14px !important;
  font-weight: 400 !important;
  letter-spacing: normal !important;
  height: auto !important;
  min-height: 0 !important;
}

.global-settings-page :deep(.gs-input .el-input__inner::placeholder) {
  font-size: 13px !important;
  color: #9ca3af !important;
}

.gs-input-stack {
  margin-bottom: 10px;
}

.field-row--top {
  align-items: flex-start;
}

.field-row--top .field-label {
  padding-top: 10px;
}

.prompt-editor {
  flex: 1;
  min-width: 0;
}

.prompt-editor__toolbar {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 8px;
}

.field-hint {
  margin: -4px 0 16px 88px;
  font-size: 12px;
  color: #64748b;
  line-height: 1.5;
}

.field-hint code {
  font-size: 11px;
  background: #f0f2f5;
  padding: 1px 5px;
  border-radius: 4px;
}

.gs-input--wide {
  flex: 1;
  min-width: 0;
}

.model-select-wide {
  width: 320px;
  max-width: 100%;
}

.provider-config-block {
  margin-bottom: 16px;
  padding: 14px 16px;
  background: #f8fafc;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
}

.provider-config-title {
  font-size: 13px;
  font-weight: 600;
  color: #374151;
  margin-bottom: 12px;
}

.global-settings-page :deep(.gs-textarea .el-textarea__inner) {
  font-size: 13px;
  line-height: 1.55;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  border-radius: 10px;
  padding: 12px;
}
</style>
